module.exports = __webpack_public_path__ + "img/case4-2.81b48218.jpg";